// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__24NK0","content":"Consent_content__92gij","footer":"Consent_footer__a9OH1"};